// Generated from Info/DBD Survivor Perks - Base mecanique.md.
// Do not hand-edit individual descriptions here; update the source file and regenerate.

export const survivorPerkDetails = {
  a_place_for_us: {
    sourceName: 'A Place For Us',
    officialDescription: 'While healing another Survivor, you both gain Elusive.\nWhenever you finish healing the Obsession, you both gain Elusive for 30s.\nWhen the trial starts, you are less likely to be the Obsession.'
  },
  ace_in_the_hole: {
    sourceName: 'Ace in the Hole',
    officialDescription: 'Whenever you loot an item from a Chest, it will have:\nA Visceral or lower rarity add-on.\n100% chance for an Uncommon or lower rarity add-on.\nWhen you escape, you keep your add-ons.'
  },
  adrenaline: {
    sourceName: 'Adrenaline',
    officialDescription: 'When all Generators are completed, if you are downed or injured, heal instantly. Then, ignoring Exhausted:\nYou gain 50% Haste for 3s.\nYou gain Exhausted for 40s.'
  },
  aftercare: {
    sourceName: 'Aftercare',
    officialDescription: "You and up to 3 Survivors see each other's Auras whenever:\nYou unhook them, or they unhook you.\nYou finish healing them, or they finish healing you.\nThis effect lasts until you are hooked."
  },
  alert: {
    sourceName: 'Alert',
    officialDescription: 'Whenever the Killer breaks a Pallet or Breakable Wall, or damages a Generator:\nYou hear a sound cue.\nYou see their Aura for 5s.'
  },
  any_means_necessary: {
    sourceName: 'Any Means Necessary',
    officialDescription: 'While next to a Dropped Pallet, use Active Ability Button 1 for 3s to reset it.\nYou see the Auras of Dropped Pallets.'
  },
  apocalyptic_ingenuity: {
    sourceName: 'Apocalyptic Ingenuity',
    officialDescription: 'After you rummage or unlock 2 Chests, while next to a Broken Pallet, use Active Ability Button 1 for 4s to create a Fragile Pallet.\nWithin 32m, you see the Auras of Broken Pallets.'
  },
  appraisal: {
    sourceName: 'Appraisal',
    officialDescription: 'When the trial starts, you earn 4 Tokens.\nSpend 1 Token to rummage an empty Chest, up to 2 times per chest.\nYou rummage Chests 80% faster.'
  },
  autodidact: {
    sourceName: 'Autodidact',
    officialDescription: 'You start the trial with 0 Tokens, up to 5, and your good basic healing Skill Checks give 15% less progress.\nWhile healing without a Med-Kit:\nWhenever you hit a basic Skill Check, you earn 1 token.\nWhenever you hit a basic Skill Check, for each Token, you gain 15% more progress.\nYou cannot get great basic Skill Checks.'
  },
  baby_sitter: {
    sourceName: 'Babysitter',
    officialDescription: "Whenever you unhook a Survivor:\nThey gain 10% Haste for 30s.\nThey leave no Pools of Blood for 30s.\nThey leave no Scratch Marks for 30s.\nYou see the Killer's Aura for 8s."
  },
  background_player: {
    sourceName: 'Background Player',
    officialDescription: 'Whenever the Killer picks-up another Survivor, for the next 10s, when you start running:\nGain 50% Haste for 5s.\nGain Exhausted for 20s.'
  },
  bada_bada_boom: {
    sourceName: 'Bada Bada Boom',
    officialDescription: "After repairing 20% of Generators, while next to a Window, use Active Ability Button 2 to trap it for 60s. All Survivors see that Window's Aura for that time.\nWhen the Killer vaults that Window, the trap explodes and they gain 50% Hindered for 4s."
  },
  balanced_landing: {
    sourceName: 'Balanced Landing',
    officialDescription: 'Whenener you fall from at least 1.25m:\nYou gain 50% Haste for 3s.\nYou gain Exhausted for 40s.\nYour stagger is 75% shorter.\nYour Grunts from falling are 100% quieter.'
  },
  bardic_inspiration: {
    sourceName: 'Bardic Inspiration',
    officialDescription: 'While idle, use Active Ability Button 1 to perform, empowering all Survivors within 16m for up to 15s. While you are performing, other Survivors will see your Aura. Roll a d20:\n1 | You scream, but nothing happens.\n2-10 | Basic Skill Checks give +1% progress.\n11-19 | Basic Skill Checks give +2% progress.\n20 | Basic Skill Checks give +3% progress.\nIf you complete the performance, this effect ends after 90s. Cooldown: 90s.'
  },
  better_than_new: {
    sourceName: 'Better Than New',
    officialDescription: 'Whenever you finish healing another Survivor, until they take damage:\nThey bless and cleanse 16% faster.\nThey heal 16% faster.\nThey unlock Chests 16% faster.'
  },
  better_together: {
    sourceName: 'Better Together',
    officialDescription: "While you are repairing a Generator:\nOther Survivors see that Generator's Aura.\nWhenever the Killer downs a Survivor, you see the Auras of all Survivors for 30s."
  },
  bite_the_bullet: {
    sourceName: 'Bite the Bullet',
    officialDescription: 'While healing, you and the healed Survivor make no noises or Grunts of Pain. Whenever you miss a basic Skill Check:\nYou lose only 1% progress.\nThe Killer is not alerted.'
  },
  blast_mine: {
    sourceName: 'Blast Mine',
    officialDescription: "After repairing 40% of Generators, while next to a Generator, use Active Ability Button 2 to trap it for 120s. All Survivors see that Generator's Aura for that time.\nWhen the Killer damages that Generator, the trap explodes, then:\nThey are stunned for 4s.\nEveryone nearby looking at the detonation is blinded."
  },
  blood_pact: {
    sourceName: 'Blood Pact',
    officialDescription: "While you are not the Obsession:\nWhile you or the Obsession are injured, you see each other's Auras.\nWhenever you finish healing the Obsession, or they finish healing you, while within 16m of each other, you both gain 7% Haste.\nWhen the trial starts, you are less likely to be the Obsession."
  },
  blood_rush: {
    sourceName: 'Blood Rush',
    officialDescription: 'Until all Generators are completed, whenever you are unhooked, for the next 60s, while Exhausted, use Active Ability Button 1 to lose Exhausted instantly.\nThis is disabled by conspicuous actions.'
  },
  boil_over: {
    sourceName: 'Boil Over',
    officialDescription: 'While carried by the Killer:\nWhenever the Killer falls from at least 1.25m, you gain 33% of your current wiggle progress.\nYour wiggle is 80% stronger.\nWithin 16m, the Killer cannot see Hook Auras.'
  },
  bond: {
    sourceName: 'Bond',
    officialDescription: "Within 36m, you see other Survivors' Auras."
  },
  circle_of_healing: {
    sourceName: 'Boon: Circle of Healing',
    officialDescription: "While next to a totem, use Active Ability Button 1 to bless it, creating a unique Boon Totem that combines all your Boons.\nSurvivors within the Boon's range:\nWhile healing without a Med-Kit, they heal others 100% faster.\nWhile injured, other Survivors see their Aura."
  },
  dark_theory: {
    sourceName: 'Boon: Dark Theory',
    officialDescription: "While next to a totem, use Active Ability Button 1 to bless it, creating a unique Boon Totem that combines all your Boons.\nSurvivors within the Boon's range gain 3% Haste. When leaving the range, this ends after 4s."
  },
  exponential: {
    sourceName: 'Boon: Exponential',
    officialDescription: "While next to a totem, use Active Ability Button 1 to bless it, creating a unique Boon totem that combines all your Boons.\nDowned Survivors within the Boon's range:\nRecover 100% faster.\nCan fully recover."
  },
  boon_illumination: {
    sourceName: 'Boon: Illumination',
    officialDescription: "While next to a totem, use Active Ability Button 1 to bless it, creating a unique Boon totem that combines all your Boons.\nSurvivors within the Boon's range:\nSee the Auras of Chests.\nSee the Auras of Generators.\nWhile you have a Boon Totem, you bless and cleanse 10% faster."
  },
  shadow_step: {
    sourceName: 'Boon: Shadow Step',
    officialDescription: "While next to a Totem, use Active Ability Button 1 to bless it, creating a unique Boon Totem that combines all your Boons. Survivors within the Boon's range:\nLeave no Scratch Marks.\nTheir Auras cannot be seen by the Killer.\nWhen leaving the range, this ends after 4s."
  },
  borrowed_time: {
    sourceName: 'Borrowed Time',
    officialDescription: 'Whenever you unhook a Survivor:\nThey retain their unhook Endurance for 10s longer.\nThey retain their unhook Haste for 10s longer.'
  },
  botany_knowledge: {
    sourceName: 'Botany Knowledge',
    officialDescription: 'You heal 50% faster.'
  },
  breakdown: {
    sourceName: 'Breakdown',
    officialDescription: "Whenever you are unhooked:\nThe Hook breaks, then is repaired after 180s.\nYou see the Killer's Aura for 6s."
  },
  breakout: {
    sourceName: 'Breakout',
    officialDescription: 'Within 5m of a carried Survivor:\nYou gain 10% Haste.\nThe carried Survivor wiggles 25% faster.'
  },
  buckle_up: {
    sourceName: 'Buckle Up',
    officialDescription: "While healing a downed Survivor, you both see the Killer's Aura.\nWhenever you finish healing a downed Survivor:\nThey gain 50% Haste for 5s.\nThey leave no Scratch Marks for 5s."
  },
  built_to_last: {
    sourceName: 'Built to Last',
    officialDescription: 'While holding a depleted item, after hiding in a Locker for 10s, it is recharged to 99%.\nEach time you recharge an item this way, it recharges 33% fewer Charges.'
  },
  calm_spirit: {
    sourceName: 'Calm Spirit',
    officialDescription: 'You do not scare Crows or scream.\nYou bless and cleanse Totems, and unlock Chests silently, but 30% slower.'
  },
  camaraderie: {
    sourceName: 'Camaraderie',
    officialDescription: 'While you are struggling on Hook, when another Survivor gets within 16m, the timer is paused for 34s.'
  },
  champion_of_light: {
    sourceName: 'Champion of Light',
    officialDescription: 'While you are using a Flashlight, you gain 50% Haste.\nWhenever you blind the Killer, they gain 20% Hindered for 6s. Cooldown: 40s.'
  },
  change_of_plan: {
    sourceName: 'Change of Plan',
    officialDescription: 'When the trial starts, you earn 2 Tokens.\nWhile hiding in a Locker and holding a non-event Toolbox, use Active Ability Button 2 and spend 1 Token to transform your Toolbox and add-ons into a Med-Kit of the same rarity with 100% Charges and random add-ons of the same rarity.'
  },
  chemical_trap: {
    sourceName: 'Chemical Trap',
    officialDescription: "After repairing 20% of Generators, while next to a Dropped Pallet, use Active Ability Button 2 to trap it for 60s. All Survivors see that Pallet's Aura for that time.\nWhen the Killer breaks that Pallet, the trap explodes and they gain 50% Hindered for 4s."
  },
  clairvoyance: {
    sourceName: 'Clairvoyance',
    officialDescription: 'Whenever you bless or cleanse a Totem, while not holding an item, use {Input.UseItem} to, for up to 12s and within 64m:\nSee the Auras of Chests.\nSee the Auras of Exit Gate Switches.\nSee the Auras of Generators.\nSee the Aura of the Hatch.\nSee the Auras of Hooks.'
  },
  clean_break: {
    sourceName: 'Clean Break',
    officialDescription: 'Whenever you finish healing another Survivor, while being healed by another Survivor, use Active Ability Button 1 to gain Broken.\nAfter 60s, if you are not downed, you are instantly healed.'
  },
  come_and_get_me: {
    sourceName: 'Come and Get Me!',
    officialDescription: 'Whenever you unhook a Survivor, while crouched and idle, use Active Ability Button 1 to make injured and downed Survivors within 24m:\nLeave no Pools of Blood for 15s.\nLeave no Scratch Marks for 15s.\nYou scream, then the Killer sees your Aura for 5s.'
  },
  conviction: {
    sourceName: 'Conviction',
    officialDescription: 'After you finish healing 1 other Survivor, while downed with at least 25% recovery, use Active Ability Button 1 to recover instantly.\nYou gain Broken, then, after 30s, you are downed instantly.'
  },
  corrective_action: {
    sourceName: 'Corrective Action',
    officialDescription: "When the trial starts, you earn 3 Tokens, up to 5.\nWhenever you hit a great basic Skill Check, earn 1 Token.\nWhenever another Survivor misses a basic Skill Check, spend 1 Token:\nThe missed Skill Check becomes a good Skill Check.\nYou see that Survivor's Aura for 6s."
  },
  counterforce: {
    sourceName: 'Counterforce',
    officialDescription: 'When the trial starts, you earn 1 Token.\nWhenever you cleanse a Totem, earn 1 Token, then, you see the Aura of the farthest Totem for 14s.\nFor each Token, you cleanse Totems 25% faster.'
  },
  cut_loose: {
    sourceName: 'Cut Loose',
    officialDescription: 'While chased by the Killer, whenever you medium or fast-vault:\nFor up to 6s, your medium and fast vaults are silent.\nDuring that time, whenever you medium or fast-vault, the timer is reset.\nCooldown: 45s.'
  },
  dance_with_me: {
    sourceName: 'Dance With Me',
    officialDescription: 'Whenever you fast-exit a Locker, medium-vault, or fast-vault, you leave no Scratch Marks for 5s. Cooldown: 15s.'
  },
  dark_sense: {
    sourceName: 'Dark Sense',
    officialDescription: 'Whenever a Generator is completed, when the Killer gets within 24m of you, you see their Aura for 10s.'
  },
  dead_hard: {
    sourceName: 'Dead Hard',
    officialDescription: 'Whenever you are unhooked, while injured and running, use Active Ability Button 1:\nYou gain Endurance for 0.5s.\nYou gain Exhausted for 40s.'
  },
  deadline: {
    sourceName: 'Deadline',
    officialDescription: 'While injured, basic Skill Checks:\nAre 10% more likely to appear.\nAppear in random places.\nWhenever you miss a basic Skill Check, you lose 50% less progress.'
  },
  deception: {
    sourceName: 'Deception',
    officialDescription: 'Whenever you attempt to fast-enter a Locker:\nYou do not enter the Locker.\nThe Killer is alerted.\nYou leave no Scratch Marks for 5s.\nCooldown: 15s.'
  },
  decisive_strike: {
    sourceName: 'Decisive Strike',
    officialDescription: 'Until all Generators are completed, whenever you are unhooked, for the next 60s: when the Killer picks you up, once per trial, hit a Special Skill check:\nStun the Killer for 4s.\nBecome the Obsession.\nThis is disabled by conspicuous actions. At the start of the trial, you are more likely to be the Obsession.'
  },
  deja_vu: {
    sourceName: 'Deja Vu',
    officialDescription: 'You see the Auras of the 3 Generators closest to each other and repair them 6% faster.'
  },
  deliverance: {
    sourceName: 'Deliverance',
    officialDescription: 'Once per trial, when you safely unhook another Survivor, you can unhook yourself. When you unhook yourself this way, you gain Broken for 60s.'
  },
  desperate_measures: {
    sourceName: 'Desperate Measures',
    officialDescription: 'For each injured, downed, or hooked Survivor:\nYou heal 20% faster.\nYou unhook 20% faster.'
  },
  detectives_hunch: {
    sourceName: "Detective's Hunch",
    officialDescription: 'Whenever a Generator is completed, for 20s, within 64m of you:\nYou see the Auras of Chests.\nYou see the Auras of Generators.\nYou see the Auras of Totems.'
  },
  distortion: {
    sourceName: 'Distortion',
    officialDescription: 'When the trial starts, and after being chased for 15s, you earn 1 Token, up to 2.\nWhile not downed, whenever the Killer attempts to see your Aura, spend 1 Token. Then, for the next 12s:\nThe Killer cannot see your Aura.\nYou leave no Scratch Marks.'
  },
  diversion: {
    sourceName: 'Diversion',
    officialDescription: "After hiding for 20s within the Killer's Terror Radius, while crouched and idle, use Active Ability Button 1 to throw a pebble 20m away:\nThe Killer is alerted.\nThe pebble leaves Scratch Marks."
  },
  do_no_harm: {
    sourceName: 'Do No Harm',
    officialDescription: 'While healing another Survivor:\nFor each Hook State they have, you heal 50% faster.\nWhenever you hit a great basic Skill Check, you gain 3% more progress.'
  },
  dramaturgy: {
    sourceName: 'Dramaturgy',
    officialDescription: 'While healthy and running, use Active Ability Button 1:\nYou gain 25% Haste for 2s.\nYou gain Exhausted for 40s.\nThen, one happens at random:\nYou gain 25% Haste for 2s.\nYou gain Exposed for 12s.\nYou gain a random rare item with random add-ons.\nYou scream, but nothing happens.\nThe same effect cannot happen twice in a row.'
  },
  duty_of_care: {
    sourceName: 'Duty of Care',
    officialDescription: 'While healthy, whenever you take a protection hit, other Survivors within 12m gain 25% Haste for 6s.'
  },
  empathic_connection: {
    sourceName: 'Empathic Connection',
    officialDescription: 'You heal other Survivors 35% faster.\nInjured Survivors see your Aura.'
  },
  empathy: {
    sourceName: 'Empathy',
    officialDescription: 'Within 128m, you see the Auras of injured Survivors.'
  },
  extrasensory_perception: {
    sourceName: 'Extrasensory Perception',
    officialDescription: 'After crouching for 4s:\nYou see Auras in an expanding radius up to 44m.\nYou gain Elusive.\nYou gain Oblivious.\nWhen you stop crouching, or after 11s, cooldown: 40s.'
  },
  exultation: {
    sourceName: 'Exultation',
    officialDescription: 'Whenever you Pallet-stun the Killer:\nYour item rarity is upgraded to the next tier, if possible.\nIf the item was upgraded, it recharges 75% Charges.\nCooldown: 20s.'
  },
  eyes_of_belmont: {
    sourceName: 'Eyes of Belmont',
    officialDescription: "Whenever a Generator is completed, you see the Killer's Aura for 3s.\nWhenever you see the Killer's Aura for a duration, it is 2s longer."
  },
  fast_track: {
    sourceName: 'Fast Track',
    officialDescription: 'Whenever you unhook another Survivor, you earn 1 Token(s), up to 1/2/3.\nWhile repairing, whenever you hit a great basic Skill Check, spend all Tokens. For each Token spent, the Generator gains 5% permanent progress.'
  },
  finesse: {
    sourceName: 'Finesse',
    officialDescription: 'While healthy, you fast-vault 20% faster.\nWhenever you fast-vault, cooldown: 30s.'
  },
  five_moves_ahead: {
    sourceName: 'Five Moves Ahead',
    officialDescription: "While you are in the Killer's Terror Radius or chased by the Killer:\nYou see the Auras of the 5 closest Pallets and Windows.\nAfter you drop a Pallet, you start moving 50% earlier.\nWhenever you drop a Pallet, cooldown: 30s."
  },
  fixated: {
    sourceName: 'Fixated',
    officialDescription: 'While walking, you gain 20% Haste.\nYou see your own Scratch Marks.'
  },
  flashbang: {
    sourceName: 'Flashbang',
    officialDescription: 'After repairing 40% of Generators, while hiding in a Locker, use Active Ability Button 1 to craft a Flashbang.\nWhen you use the Flashbang:\nEveryone nearby looking at the detonation is blinded.\nThe Killer is alerted.'
  },
  flip_flop: {
    sourceName: 'Flip-Flop',
    officialDescription: 'While downed, whenever the Killer picks you up, 50% of your recovery progress is added to your wiggle progress, up to 50%.'
  },
  flow_state: {
    sourceName: 'Flow State',
    officialDescription: 'Whenever a generator is completed, earn 1 Token, up to 5.\nFor each Token:\nYou bless and cleanse 10% faster.\nYou heal 10% faster.\nYou unhook Survivors 10% faster.'
  },
  fogwise: {
    sourceName: 'Fogwise',
    officialDescription: "While repairing, whenever you hit a great basic Skill Check, you see the Killer's Aura for 6s."
  },
  for_the_people: {
    sourceName: 'For the People',
    officialDescription: 'While healthy and healing another Survivor without a Med-Kit, use Active Ability Button 1 to heal them instantly:\nYou take damage.\nYou gain Broken for 60s.\nYou become the Obsession.\nWhen the trial starts, you are less likely to be the Obsession.'
  },
  friendly_competition: {
    sourceName: 'Friendly Competition',
    officialDescription: 'Whenever you finish repairing a Generator with at least 1 other Survivor, Survivors who finished repairing it repair 5% faster for 120s.'
  },
  ghost_notes: {
    sourceName: 'Ghost Notes',
    officialDescription: 'While you have Exhausted, your Scratch Marks disappear 50% faster.\nYou lose Exhausted 10% faster.'
  },
  hardened: {
    sourceName: 'Hardened',
    officialDescription: "When you have blessed or cleansed a Totem and unlocked a Chest, whenever you would scream, you see the Killer's Aura for 5s instead."
  },
  head_on: {
    sourceName: 'Head On',
    officialDescription: 'After hiding in a Locker for 3s, fast-exit to stun the Killer for 3s if they are within 2.5m, then gain Exhausted for 40s.'
  },
  hope: {
    sourceName: 'Hope',
    officialDescription: 'When all Generators are completed, you gain 5% Haste.'
  },
  hyperfocus: {
    sourceName: 'Hyperfocus',
    officialDescription: 'Whenever you hit a great basic Skill Check, you earn 1 Token, up to 6.\nFor each Token, basic Skill Checks:\nAppear 4% more often.\nSpin 4% faster.\nWhenever you hit a great, give 30% more progress.\nWhenever you miss a basic Skill Check, hit a good Skill Check, or stop healing or repairing, lose all Tokens.'
  },
  inner_focus: {
    sourceName: 'Inner Focus',
    officialDescription: "Whenever the Killer damages another Survivor, you see the Killer's Aura for 10s.\nYou see other Survivors' Scratch Marks."
  },
  inner_strength: {
    sourceName: 'Inner Strength',
    officialDescription: 'Whenever you cleanse a Totem, while injured and not Broken, after hiding in a Locker for 8s, you become healthy instantly.'
  },
  treacherous_crows: {
    sourceName: 'Invocation: Treacherous Crows',
    officialDescription: "While in the Basement next to the circle, use Active Ability Button 2 to invoke. While invoking, other Survivors see your Aura and can join your Invocation.\nWhen the Invocation is completed:\nWhenever the Killer scares a Crow while a Survivor is in their Terror Radius, all Survivors see the Killer's Aura for 2s.\nYou become injured.\nYou gain Broken.\nEach Invocation can only be completed once per trial."
  },
  invocation_weaving_spiders: {
    sourceName: 'Invocation: Weaving Spiders',
    officialDescription: 'While in the Basement next to the circle, use Active Ability Button 1 to invoke. While invoking, other Survivors see your Aura and can join your Invocation.\nWhen the Invocation is completed:\nAll Generators gain 10 permanent charges.\nYou become injured.\nYou gain Broken.\nEach Invocation can only be completed once per trial.'
  },
  iron_will: {
    sourceName: 'Iron Will',
    officialDescription: 'While injured and not Exhausted, your Grunts of Pain are 100% quieter.'
  },
  kindred: {
    sourceName: 'Kindred',
    officialDescription: "While you are hooked, all Survivors see each others' Auras. While the Killer is within 16m, all Survivors sees the Killer's Aura.\nWhile another Survivor is hooked, you see the Auras of other Survivors. While the Killer is within 16m of the hooked Survivor, you see the Killer's Aura."
  },
  last_stand: {
    sourceName: 'Last Stand',
    officialDescription: "After hiding for 90s within the Killer's Terror Radius, when you fast-vault, once per trial, stun the Killer for 3s if they are within 2.5m."
  },
  leader: {
    sourceName: 'Leader',
    officialDescription: 'Within 10m of you, other Survivors:\nCleanse Totems 30% faster.\nHeal 30% faster.\nOpen Exit Gates 30% faster.\nSabotage Hooks 30% faster.\nUnhook Survivors 30% faster.\nUnlock Chests 30% faster.\nAfter they leave your range, this ends after 20s.'
  },
  left_behind: {
    sourceName: 'Left Behind',
    officialDescription: "When all other Survivors are dead, while within 32m of the Hatch, you see it's Aura."
  },
  light_footed: {
    sourceName: 'Light-footed',
    officialDescription: 'While healthy and running, your footsteps are silent to the Killer.\nWhenever you do a fast-action, cooldown: 10s.'
  },
  lightweight: {
    sourceName: 'Lightweight',
    officialDescription: 'Your Scratch Marks disappear 5s faster and appear more spread out.'
  },
  lithe: {
    sourceName: 'Lithe',
    officialDescription: 'Whenever you medium or fast-vault:\nYou gain 50% Haste for 3s.\nYou gain Exhausted for 40s.'
  },
  low_profile: {
    sourceName: 'Low Profile',
    officialDescription: 'When all other Survivors are downed or hooked, for 90s:\nYou make no Grunts of Pain.\nYou leave no Pools of Blood.\nYou leave no Scratch Marks.'
  },
  lucky_break: {
    sourceName: 'Lucky Break',
    officialDescription: 'While injured, for up to 60s:\nYou leave no Pools of Blood.\nYou leave no Scratch Marks.\nFor each second spent healing another Survivor, recharge the duration by 1s.'
  },
  lucky_star: {
    sourceName: 'Lucky Star',
    officialDescription: 'While hiding in a Locker, you make no Grunts of Pain.\nWhenever you exit a Locker, for 30s:\nYou see the Aura of the closest Generator.\nYou see the Auras of other Survivors.\nYou make no Grunts of Pain.\nYou leave no Pools of Blood.\nCooldown: 25s.'
  },
  made_for_this: {
    sourceName: 'Made for This',
    officialDescription: 'While injured, whenever you finish healing another Survivor, you gain Endurance for 10s.\nWhile you have Deep Wound, you gain 3% Haste.'
  },
  mettle_of_man: {
    sourceName: 'Mettle of Man',
    officialDescription: 'After taking 3 protection hits, while injured and until you go down, the next time you would be downed by the Killer, take no damage instead.\nWhen you become healthy, while you are at least 16m from the Killer, they see your Aura.\nWhen the trial starts, you are more likely to be the Obsession.'
  },
  mirrored_illusion: {
    sourceName: 'Mirrored Illusion',
    officialDescription: 'After repairing 20% of Generators, while next to a Chest, Exit Gate Switch, Generator, or Totem, use Active Ability Button 2 to create a static illusion for 60s.'
  },
  moment_of_glory: {
    sourceName: 'Moment of Glory',
    officialDescription: 'After you rummage or unlock 2 Chests, while not Broken, when you become injured, gain Broken.\nIf you do not take damage, after 60s, you are instantly healed.'
  },
  no_mither: {
    sourceName: 'No Mither',
    officialDescription: 'When the trial starts, you become injured, then:\nYou gain Broken.\nYour Grunts of Pain are 100% quieter.\nYou leave no Pools of Blood.\nYou recover 25% faster.\nYou can fully recover.'
  },
  no_one_left_behind: {
    sourceName: 'No One Left Behind',
    officialDescription: 'When all Generators are completed:\nYou heal 100% faster.\nYou unhook other Survivors 100% faster.\nWhenever you unhook a Survivor, they gain 10% more Haste.\nYou see the Auras of other Survivors.'
  },
  object_of_obsession: {
    sourceName: 'Object of Obsession',
    officialDescription: 'While you are the Obsession, every 30s, the Killer sees your Aura for 3s.\nWhile the Killer sees your Aura:\nYou see their Aura.\nYou cleanse totems 6% faster.\nYou heal 6% faster.\nYou repair 6% faster.\nWhen the trial starts, you are more likely to be the Obsession.'
  },
  off_the_record: {
    sourceName: 'Off the Record',
    officialDescription: 'Until all Generators are completed, whenever you are unhooked, for the next 40s:\nYou gain Endurance.\nYour Grunts of Pain are 100% quieter.\nThe Killer cannot see your Aura.'
  },
  one_two_three_four: {
    sourceName: 'ONE-TWO-THREE-FOUR!',
    officialDescription: 'While idle, use Active Ability Button 2 to perform, empowering all Survivors within 16m for up to 15s. While you are performing, other Survivors will see your Aura. You get special Skill Checks during that time: while healing or repairing, basic Skill Checks are 20% more likely to appear.\nIf you complete the performance, the effect ends after 90s. Cooldown: 90s.'
  },
  open_handed: {
    sourceName: 'Open-Handed',
    officialDescription: 'All Survivors see Auras that have a range from 16m farther.'
  },
  overcome: {
    sourceName: 'Overcome',
    officialDescription: 'Whenever you take damage:\nYou retain your speed boost for 2s longer.\nYou gain Exhausted for 40s.'
  },
  overzealous: {
    sourceName: 'Overzealous',
    officialDescription: 'Whenever you bless or cleanse a Totem, until you take damage, you repair 10% faster. If that Totem was a Hex Totem, the effect is doubled.'
  },
  parental_guidance: {
    sourceName: 'Parental Guidance',
    officialDescription: 'Whenever you stun the Killer, for 7s:\nYou make no Grunts of Pain.\nYou leave no Pools of Blood.\nYou leave no Scratch Marks.'
  },
  pharmacy: {
    sourceName: 'Pharmacy',
    officialDescription: 'Whenever you unlock a Chest, it will contain a rare Med-Kit.\nYou unlock Chests 125% faster.\nThe range at which the Killer hears you unlocking Chests is 12m shorter.'
  },
  plot_twist: {
    sourceName: 'Plot Twist',
    officialDescription: 'While injured, crouched and idle, use Active Ability Button 2 to be downed silently.\nWhile downed this way, once per trial:\nYou make no Grunts of Pain.\nYou leave no Pools of Blood.\nYou recover 25% faster.\nYou can fully recover.\nWhenever you recover this way:\nYou gain 50% Haste for 4s.\nYou are healed instantly.\nWhen all Generators are completed, you can use this ability once again.'
  },
  plunderers_instinct: {
    sourceName: "Plunderer's Instinct",
    officialDescription: 'Within 64m of locked Chests and dropped items, you see their Auras.\nWhenever you unlock a Chest, you are 50% more likely to find an item of higher rarity.'
  },
  poised: {
    sourceName: 'Poised',
    officialDescription: "The first time you start repairing each Generator, you see the Killer's Aura for 8s.\nWhenever a Generator is completed, you leave no Scratch Marks for 30s."
  },
  potential_energy: {
    sourceName: 'Potential Energy',
    officialDescription: 'While repairing, use Active Ability Button 2 to earn Tokens instead of progress, up to 20 Tokens.\nWhile you have at least 1 Token, Active Ability Button 2 to spend all Tokens and gain 1% progress for each Token spent.\nWhenever you take damage, lose all Tokens.'
  },
  power_struggle: {
    sourceName: 'Power Struggle',
    officialDescription: 'While carried by the Killer, while you have at least 15% wiggle and next to an Upright Pallet, you can drop it to stun the Killer.\nWhile downed, you see the Auras of Upright Pallets.'
  },
  premonition: {
    sourceName: 'Premonition',
    officialDescription: 'While the Killer is within 36m of you and inside a 45 degree cone, whenever you look at them, you hear a sound cue. Cooldown: 30s.'
  },
  prove_thyself: {
    sourceName: 'Prove Thyself',
    officialDescription: 'For each other Survivor within 4m of you, all Survivors repair 10% faster.'
  },
  quick_and_quiet: {
    sourceName: 'Quick & Quiet',
    officialDescription: 'You hide in Lockers and vault silently. The Killer is not alerted. Cooldown: 15s.'
  },
  quick_gambit: {
    sourceName: 'Quick Gambit',
    officialDescription: 'While chased by the Killer:\nYou see the Auras of other Survivors.\nOther Survivors repair 5% faster.\nWhenever you take damage, cooldown: 40s.'
  },
  rapid_response: {
    sourceName: 'Rapid Response',
    officialDescription: "Whenever you fast-exit a Locker, you gain Exhausted for 20s.\nWhenever you gain Exhausted, you see the Killer's Aura for 2s."
  },
  reactive_healing: {
    sourceName: 'Reactive Healing',
    officialDescription: 'While injured, whenever another Survivor within 32m of you takes damage, you gain 50% missing healing progress.'
  },
  reassurance: {
    sourceName: 'Reassurance',
    officialDescription: 'Once per Hook State, while within 6m of a hooked Survivor, use Active Ability Button 2 to stop the sacrifice progress for 30s.'
  },
  red_herring: {
    sourceName: 'Red Herring',
    officialDescription: 'After you repair a Generator for at least 1s, you see its Aura.\nWhen you hide in a Locker, the Killer is alerted to the Generator. Cooldown: 15s.'
  },
  repressed_alliance: {
    sourceName: 'Repressed Alliance',
    officialDescription: 'After repairing Generators for 45s, while repairing a Generator alone, use Active Ability Button 1 to block that generator for 30s.'
  },
  residual_manifest: {
    sourceName: 'Residual Manifest',
    officialDescription: 'Whenever you blind the Killer, they gain Blindness for 30s.\nYou can rummage Chests 1 time. The first time you rummage a Chest, it will contain an uncommon Flashlight.'
  },
  resilience: {
    sourceName: 'Resilience',
    officialDescription: 'While injured:\nYou bless and cleanse Totems 9% faster.\nYou heal 9% faster.\nYou open Exit Gates 9% faster.\nYou repair 9% faster.\nYou sabotage Hooks 9% faster.\nYou unhook Survivors 9% faster.\nYou unlock chests 9% faster.\nYou vault 9% faster.'
  },
  resurgence: {
    sourceName: 'Resurgence',
    officialDescription: 'Whenever you are unhooked, you gain 70% healing progress.'
  },
  road_life: {
    sourceName: 'Road Life',
    officialDescription: 'While injured, not Broken and repairing a Generator:\nWhenever you hit a basic great Skill Check, you earn 1 Token.\nWhenever you miss a basic Skill Check, you lose 1 token.\nWhen you have 4 Tokens, spend all Tokens to heal 100% faster until you stop healing.'
  },
  rookie_spirit: {
    sourceName: 'Rookie Spirit',
    officialDescription: 'After you hit 3 basic repair Skill Checks, while a Generator is regressing, you see its Aura.'
  },
  saboteur: {
    sourceName: 'Saboteur',
    officialDescription: 'Within 56m of where another Survivor was picked-up by the Killer and is being carried, you see the Auras of Hooks and Scourge Hooks.\nYou can sabotage Hooks. Cooldown: 60s.'
  },
  scavenger: {
    sourceName: 'Scavenger',
    officialDescription: 'While repairing and while your Toolbox is empty, whenever you hit a great basic Skill Check, you earn 1 Token.\nWhen you have 5 Tokens, spend them all:\nYour Toolbox is recharged instantly.\nYou repair 50% slower for 30s.\nYou can rummage Chests 1 time. The first time you rummage a Chest, it will contain an uncommon Toolbox.'
  },
  scene_partner: {
    sourceName: 'Scene Partner',
    officialDescription: "While you are within the Killer's Terror Radius, whenever you look at them:\nScream, then see the Killer's Aura for 6s.\nThere is a 50% chance you will scream again.If you do, you see the Killer's Aura for 2s more.\nCooldown: 40s."
  },
  second_wind: {
    sourceName: 'Second Wind',
    officialDescription: 'After you heal 1 Survivor, while not Broken, when you are unhooked, you gain Broken.\nAfter 20s, if you are not downed, you are instantly healed.'
  },
  self_care: {
    sourceName: 'Self-Care',
    officialDescription: 'You can heal yourself at 35% speed.'
  },
  self_preservation: {
    sourceName: 'Self-Preservation',
    officialDescription: 'Whenever another Survivor is hooked, you gain Elusive for 30s.'
  },
  shoulder_the_burden: {
    sourceName: 'Shoulder the Burden',
    officialDescription: 'Once per trial, while you do not have 2 Hook States and are next to a hooked Survivor, use Active Ability Button 2 to unhook them:\nThey lose 1 Hook State.\nYou gain 1 Hook State.\nYou scream.\nYou gain Exposed for 40s.'
  },
  slippery_meat: {
    sourceName: 'Slippery Meat',
    officialDescription: 'You can attempt to unhook yourself up to 3 times and have 4% more chance to succeed.'
  },
  small_game: {
    sourceName: 'Small Game',
    officialDescription: 'Within 12m of you, whenever you look at a Totem in a 45 degree cone, you hear a sound cue. Cooldown: 10s.\nWhenever a Survivor cleanses a Totem, you earn 1 Token, up to 5.\nFor each Token, the cone is 5 degrees smaller.'
  },
  smash_hit: {
    sourceName: 'Smash Hit',
    officialDescription: 'Whenever you Pallet-stun the Killer:\nYou gain 50% Haste for 4s.\nYou gain Exhausted for 20s.'
  },
  sole_survivor: {
    sourceName: 'Sole Survivor',
    officialDescription: 'Whenever a Survivor dies, you earn 1 Token.\nFor each Token, within 24m, the Killer cannot see your Aura.\nWhen all other Survivors are dead:\nYou repair 75% faster.\nYou open Exit Gates and the Hatch 50% faster.\nWhen the trial starts, you are more likely to be the Obsession.'
  },
  solidarity: {
    sourceName: 'Solidarity',
    officialDescription: 'While injured and healing another Survivor without a Med-Kit, you also gain healing progress at 70% speed.'
  },
  soul_guard: {
    sourceName: 'Soul Guard',
    officialDescription: 'While hexed, you can fully recover.\nWhenever you fully recover, you gain Endurance for 8s. Cooldown: 30s.'
  },
  specialist: {
    sourceName: 'Specialist',
    officialDescription: 'Whenever you rummage or unlock a Chest, you earn 1 Token, up to 6.\nWhile repairing a Generator, whenever you hit a great basic Skill Check, spend all Tokens. For each Token spent, the Generator gains 4% permanent progress.'
  },
  spine_chill: {
    sourceName: 'Spine Chill',
    officialDescription: 'Within 36m, whenever the Killer looks at you, you hear a sound cue.\nWithin 36m, while the Killer is looking at you:\nYou bless and cleanse Totems 6% faster.\nYou heal 6% faster.\nYou open Exit Gates 6% faster.\nYou repair Generators 6% faster.\nYou sabotage Hooks 6% faster.\nYou unhook Survivors 6% faster.\nYou unlock Chests 6% faster.'
  },
  sprint_burst: {
    sourceName: 'Sprint Burst',
    officialDescription: 'Whenever you start running:\nYou gain 50% Haste for 3s.\nYou gain Exhausted for 40s.'
  },
  stake_out: {
    sourceName: 'Stake Out',
    officialDescription: "After hiding for 15s within the Killer's Terror Radius, you earn 1 Token, up to 2/3/4.\nWhenever you hit a good basic Skill Check, spend 1 Token:\nThe good Skill Check becomes a great Skill Check.\nYou gain 1% more progress."
  },
  still_sight: {
    sourceName: 'Still Sight',
    officialDescription: "After being idle for 2s, within 24m, until you start moving:\nYou see the Killer's Aura.\nYou see the Auras of Chests.\nYou see the Auras of Generators."
  },
  streetwise: {
    sourceName: 'Streetwise',
    officialDescription: "The first time you deplete an Item's Charges, you see the Killer's Aura for 8s.\nWhenever you loot an item from a Chest, it has 80% more Charges."
  },
  strength_in_shadows: {
    sourceName: 'Strength in Shadows',
    officialDescription: "While in the Basement:\nYou can heal yourself at 70% speed.\nWhenever you finish healing, you see the Killer's Aura for 10s."
  },
  teamwork_collective_stealth: {
    sourceName: 'Teamwork: Collective Stealth',
    officialDescription: 'Whenever another Survivor finishes healing you, while within 16m of each other, you both leave no Scratch Marks. When either of you leaves the range, this ends after 4s.'
  },
  teamwork_full_circuit: {
    sourceName: 'Teamwork: Full Circuit',
    officialDescription: 'For each other Survivor repairing a Generator with you, good basic Skill Check zones are 25% bigger.\nWhile repairing with at least 1 other Survivor, you repair 5% faster.'
  },
  teamwork_power_of_two: {
    sourceName: 'Teamwork: Power of Two',
    officialDescription: 'Whenever you finish healing another Survivor, while you stay within 16m of each other, you both gain 5% Haste. When either of you leaves the range, this ends after 4s.'
  },
  teamwork_soft_spoken: {
    sourceName: 'Teamwork: Soft-Spoken',
    officialDescription: 'For each other Survivor repairing a Generator with you, the range of Generator repair noises is 25% smaller.\nWhile repairing with at least 1 other Survivor, you repair 5% faster.'
  },
  teamwork_throw_down: {
    sourceName: 'Teamwork: Throw Down',
    officialDescription: "Whenever you blind or Pallet-stun the Killer, for 10s, other injured Survivors within 24m:\nGain Endurance.\nSee the Killer's Aura."
  },
  teamwork_toughen_up: {
    sourceName: 'Teamwork: Toughen Up',
    officialDescription: 'Whenever another Survivor within 24m of you blinds or Pallet-stuns the Killer, for 30s:\nYou make no Grunts of Pain.\nYou leave no Pools of Blood.\nYou leave no Scratch Marks.'
  },
  technician: {
    sourceName: 'Technician',
    officialDescription: 'While repairing a Generator:\nThe range of Generator repair noises is 8m shorter.\nWhenever you miss a basic Skill Check, the Generator does not explode, but loses 3% more progress.'
  },
  tenacity: {
    sourceName: 'Tenacity',
    officialDescription: 'While downed:\nYou gain 50% Haste.\nYou can crawl and recover at the same time.\nYour Grunts of Pain are 75% quieter.'
  },
  this_is_not_happening: {
    sourceName: 'This Is Not Happening',
    officialDescription: 'While injured, great basic Skill Check zones are 30% bigger.'
  },
  troubleshooter: {
    sourceName: 'Troubleshooter',
    officialDescription: "While chased by the Killer:\nYou see the Aura of the Generator with the most progress.\nWhenever you drop a Pallet, you see the Killer's Aura for 6s.\nWhen the Killer stops chasing you, this ends after 10s."
  },
  unbreakable: {
    sourceName: 'Unbreakable',
    officialDescription: 'Once per trial, while downed by the Killer, you can fully recover.\nWhile downed, you recover 35% faster.'
  },
  up_the_ante: {
    sourceName: 'Up the Ante',
    officialDescription: 'For each other Survivor alive, all Survivors are 3% luckier.\nAll Survivors can attempt to unhook themselves.'
  },
  urban_evasion: {
    sourceName: 'Urban Evasion',
    officialDescription: 'While crouched, you gain 100% Haste.'
  },
  vigil: {
    sourceName: 'Vigil',
    officialDescription: 'All Survivors within 16m of you:\nLose Blindness 66% faster.\nLose Broken 66% faster.\nLose Exhausted 66% faster.\nLose Exposed 66% faster.\nLose Hemorrhage 66% faster.\nLose Hindered 66% faster.\nLose Mangled 66% faster.\nLose Oblivious 66% faster.\nAfter they leave your range, this ends after 15s.'
  },
  visionary: {
    sourceName: 'Visionary',
    officialDescription: 'Within 32m of you, you see the Auras of Generators.\nWhenever a Generator is completed, cooldown: 16s.'
  },
  wake_up: {
    sourceName: 'Wake Up!',
    officialDescription: 'When all Generators are completed:\nYou see the Auras of Exit Gate Switches.\nWhile opening an Exit Gate, other Survivors see your Aura.\nFor each Survivor alive, you open Exit Gates 12.5% faster.'
  },
  we_see_you: {
    sourceName: 'We See You',
    officialDescription: "Whenever the Killer sees your Aura, you earn 1 Token. Cooldown: 10s.\nWhen you have 4 Tokens, spend them all. Then, all Survivors see the Killer's Aura for 15s."
  },
  well_make_it: {
    sourceName: "We'll make it",
    officialDescription: 'Whenever you unhook a Survivor, for 90s, you heal other Survivors 100% faster.'
  },
  were_gonna_live_forever: {
    sourceName: "We're Gonna Live Forever",
    officialDescription: 'You heal downed Survivors 100% faster.\nWhenever you finish healing a downed Survivor, they gain Endurance for 10s. Cooldown: 30s.'
  },
  wicked: {
    sourceName: 'Wicked',
    officialDescription: "While in the Basement, you can unhook yourself.\nWhenever you are unhooked, you see the Killer's Aura for 20s."
  },
  windows_of_opportunity: {
    sourceName: 'Windows of Opportunity',
    officialDescription: 'Within 32m of you:\nYou see the Auras of Pallets.\nYou see the Auras of Breakable Walls.\nYou see the Auras of Windows.'
  },
  wiretap: {
    sourceName: 'Wiretap',
    officialDescription: "After repairing 40% of Generators, while next to a Generator, use Active Ability Button 2 to trap it for 120s or until the Killer damages that Generator. All Survivors see that Generator's Aura for that time.\nWhile the Killer is within 14m of that Generator, all Survivors see the Killer's Aura."
  }
}

export function getSurvivorPerkDetails (perkId) {
  return survivorPerkDetails[perkId] || null
}

export default survivorPerkDetails
